import {ComponentInitializer} from '@/components/initializers/ComponentInitializer';

type ComponentConstructor<T extends any[]> = new (element: Element, ...options: T)  => object;

export class ClassComponentInitializer<T extends any[] = []> implements ComponentInitializer {
    private readonly selector: string;
    private readonly component: ComponentConstructor<T>;
    private readonly options: T;


    public constructor(selector: string, component: ComponentConstructor<T>, ... options: T) {
        this.selector = selector;
        this.component = component;
        this.options = options;
    }

    public initialize(container: HTMLElement): void {
        container.querySelectorAll(this.selector).forEach(element => {
            // tslint:disable no-unused-expression
            new this.component(element, ...this.options);
        });
    }
}
